import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import {controlDesignEffectivenessTypeId} from '../../../../../../../util/uiconstants';

function ISA315ItControlEffectivenessType({itControlEffectivenessTypeId}) {
	switch (itControlEffectivenessTypeId) {
		case controlDesignEffectivenessTypeId.Effectiveness:
			return (
				<StyledEffectiveLabel className="StyledEffectiveLabel">
					{labels.controlDesignEffectiveness[1].description}
				</StyledEffectiveLabel>
			);

		case controlDesignEffectivenessTypeId.No_Effectiveness:
			return (
				<StyledInEffectiveLabel className="StyledInEffectiveLabel">
					{labels.controlDesignEffectiveness[2].description}
				</StyledInEffectiveLabel>
			);

		case controlDesignEffectivenessTypeId.Null:
			return (
				<StyledNotSelectedLabel className="StyledNotSelectedLabel">
					{labels.controlDesignEffectiveness[0].description}
				</StyledNotSelectedLabel>
			);

		default:
			return (
				<StyledNotSelectedLabel className="StyledNotSelectedLabel">
					{labels.controlDesignEffectiveness[0].description}
				</StyledNotSelectedLabel>
			);
	}
}

export default ISA315ItControlEffectivenessType;

const StyledEffectiveLabel = styled.section`
	font-size: var(--px-14);
	font-weight: normal;
	color: var(--neutrals-900);
`;

const StyledInEffectiveLabel = styled.section`
	font-size: var(--px-14);
	font-weight: bold;
	color: var(--neutrals-900);
`;

const StyledNotSelectedLabel = styled.section`
	font-size: var(--px-14);
	font-weight: 300;
	font-style: italic;
	color: var(--neutrals-700);
`;
